import type { TableSettingsState } from '@/helpers/cookieStorage/userSettings/tableSettings/shared'

export const VAULT_LISTING_DEFAULT_TABLE_SETTINGS: TableSettingsState = {
  columnVisibility: {},
  sorting: [
    {
      id: 'allocation',
      desc: true
    }
  ],
  columnFilters: [],
  columnOrder: [],
  version: 1
}
export const VAULT_LISTING_STORAGE_KEY = 'vaultListingTable'
